<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from "echarts"
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '550px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions({ timeList, firstList,rechargeList} = {}) {
      this.chart.setOption({
        title: {
          text: '日首充复充统计',
          subtext: '每日首充复充个数分析'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: false }
          }
        },
        color: ['#34bfa3','#f4516c', '#36a3f7'],
        legend: {
          data: ['首充数', '复充数']
        },
        xAxis: [
          {
            type: 'category',
            data: timeList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '首充数',
            type: 'bar',
            data: firstList
          },
          {
            name: '复充数',
            type: 'bar',
            data: rechargeList
          },
          {
            name: '首充数走势',
            type: 'line',
            label: {
                show: false,
            },
            tooltip: {
                show: false,
            },
            itemStyle: {
                color: '#4870DB',
            },
            lineStyle:{
                width:1
            },
            data: firstList
          }
        ]
      })
    }
  }
}
</script>
